import { Pill } from "@/components/ui/pill";
import type { ProductionOrder } from "../../types/production-orders.types.js";

/**
 * Spec 084 — ordem agendada antes de uma característica obrigatória existir. Ela não é cancelada:
 * fica sinalizada, e se iniciar assim a batelada nasce com "não informado" naquela característica.
 */
export function MarkingPendingPill({ order }: { order: ProductionOrder }) {
  if (order.missingRequiredCharacteristics.length === 0) return null;
  return (
    <Pill
      tone="warning"
      withDot
      title={`Falta informar: ${order.missingRequiredCharacteristics.join(", ")}`}
    >
      Pendente de marcação
    </Pill>
  );
}
